import classnames from 'classnames'
import * as React from 'react'

/**
 * Footer container which renders border and aligns items to right
 */
export function DialogFooter(props: React.PropsWithChildren<React.HTMLProps<HTMLDivElement>>) {
  return (
    <div
      {...props}
      className={classnames(
        props.className,
        'flex shrink-0 justify-end space-x-2 border-t border-gray-100 p-3 dark:border-gray-600'
      )}
    >
      {props.children}
    </div>
  )
}
